import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
import * as Sentry from "@sentry/react";

let common_hu = require('./translations/hu/common-felhomatrac.json');
let common_en = require('./translations/en/common-felhomatrac.json');

i18next.init({
  interpolation: {escapeValue: false},
  lng: 'hu',
  resources: {
    en: {
      common: common_en
    },
    hu: {
      common: common_hu
    }
  },
});

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://6c73f36cbe230a318430068ebb6e5f7a@o4506129787322368.ingest.us.sentry.io/4508680442609664",
    integrations: [],
  });
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <I18nextProvider i18n={i18next}>
      <App/>
    </I18nextProvider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
